var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1300 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #f99278;\n      }\n\n      .cls-5 {\n        fill: #f2ebf0;\n      }\n\n      .cls-6 {\n        fill: #fad4a1;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #a09b9e;\n      }\n\n      .cls-9 {\n        fill: #8a8e61;\n      }\n\n      .cls-10 {\n        fill: #b2c8ff;\n      }\n\n      .cls-11 {\n        fill: #d8d2d6;\n      }\n\n      .cls-12 {\n        fill: #444857;\n      }\n\n      .cls-13 {\n        fill: #29190f;\n      }\n\n      .cls-14 {\n        fill: #54596b;\n      }\n\n      .cls-3 {\n        mix-blend-mode: overlay;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 650,
    y1: 1345.39,
    x2: 650,
    y2: 177.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ff784c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4cb7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1300,77.54v844.91c0,42.82-34.54,77.54-77.13,77.54H77.13c-42.6,0-77.13-34.72-77.13-77.54V77.54C0,34.72,34.54,0,77.13,0h1145.74c42.6,0,77.13,34.72,77.13,77.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m93.72,104.99h71.8c9.53,0,17.26-7.77,17.26-17.35h0c0-9.58-7.73-17.35-17.26-17.35h-71.8c-9.53,0-17.26,7.77-17.26,17.35h0c0,9.58,7.73,17.35,17.26,17.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1186.21,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1129.36,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1072.51,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m720.45,195.25s-22.02,70.45,57.23,101.48c88.53,34.66,188.73,135,113.25,235.87-75.47,100.86-372.5-24.25-372.5-24.25,0,0-130.93-97.35-38.86-241.4,51.95-81.28,67.38-123.47,67.38-123.47l173.5,51.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 632.07,
    cy: 181.62,
    rx: 93.52,
    ry: 94.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 615.46,
    cy: 200.87,
    rx: 79.61,
    ry: 80.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m638.25,285.84l-48.88,14.94c-36.55,7.5-69.17-24.29-62.85-61.25l11.79-58.48,110.72-3.76-10.78,108.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m598.08,196.32c-2.1-2.03-4.49-3.45-7.25-4.38-3.06-1.02-4.36,3.82-1.33,4.83,1.95.65,3.57,1.66,5.05,3.09,2.32,2.24,5.84-1.3,3.52-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m560.6,195.38c-2.1-2.03-4.49-3.45-7.25-4.38-3.06-1.02-4.36,3.82-1.33,4.83,1.95.65,3.57,1.66,5.05,3.09,2.32,2.24,5.84-1.3,3.52-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m600.79,111.66c-14.07-2.63-25.97,20.86-25.97,20.86,0,0,35.67-2.42,57.25,50.29,12.99,31.74,29.19,33,30.17,46.17,11.84,16.79,28.28,4.89,28.28,4.89,0,0,28.92-53.58-5.63-90.72-22.15-23.81-57.13-26.45-84.09-31.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "702.18 358.88 612.88 358.88 581.44 223.16 670.74 223.16 702.18 358.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 682.77,
    cy: 235.4,
    rx: 32.91,
    ry: 23.7,
    transform: "translate(46.01 576.18) rotate(-47.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m677.25,234.93c8.34-11.58,20.71-10.79,20.84-10.78l.35-4.62c-.62-.05-15.08-.98-24.92,12.68l3.73,2.72Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "599.53 301.96 617.8 295.91 616.36 291.51 598.09 297.56 599.53 301.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m565.02,258.63c2.11,0,4.49-.1,6.9-.39,7.32-.88,14.32-5.18,14.62-5.36l-2.42-3.95c-.07.04-6.46,3.95-12.75,4.71-6.52.78-13.06,0-13.13,0l-.56,4.6c.19.02,3.24.39,7.33.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m558.4,236.67l3.86-2.54c-1.48-2.27-2.79-4.96-3.16-6.37,1.32-.07,4.06.36,6.45,1.02l2.48.69,2.09-12.93-4.55-.75-1.28,7.91c-2.7-.56-6.29-.99-8.19.16-.83.5-1.4,1.27-1.6,2.17-.7,3.1,2.5,8.47,3.91,10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m593.21,213.5c0,3.78-1.66,6.85-3.7,6.85s-3.7-3.07-3.7-6.85h7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m557.7,213.5c0,3.78-1.66,6.85-3.7,6.85s-3.7-3.07-3.7-6.85h7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m672.94,266.95c3.97,0,7.61-1,7.79-1.05l-1.23-4.46s-4.99,1.36-8.94.71c-4.26-.71-8.78-4.47-8.82-4.51l-2.96,3.55c.22.19,5.51,4.61,11.03,5.52,1.03.17,2.09.24,3.12.24Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m376.87,802.96h0c-35.96-20.49-48.59-66.4-28.21-102.54l160.77-283.99c20.38-36.15,66.04-48.85,102-28.36h0c35.96,20.49,48.59,66.4,28.21,102.54l-160.77,283.99c-20.38,36.15-66.04,48.85-102,28.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "723.32 857.37 723.32 1000 484.29 1000 478.52 902.79 478.28 898.9 475.91 859.32 475.79 857.37 723.32 857.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "825.43 1000 598.21 1000 598.09 969.24 598.09 969.2 597.9 902.79 597.74 857.37 597.66 831.1 597.66 824.39 597.58 805.67 597.54 793.39 597.5 778.84 820.56 778.84 821.51 821.76 821.55 823.47 821.63 827.25 821.95 841.51 823.17 897.71 823.29 902.79 825.43 1000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m621.22,797.85v197.22s-62.63-63.19-80.7-120.83c-18.07-57.64-20.15-95.38-20.15-95.38l100.85,18.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m964.49,800.62h0c34.54-22.81,44.16-69.45,21.47-104.18l-178.93-272.79c-22.69-34.73-69.08-44.39-103.63-21.59h0c-34.54,22.81-44.16,69.45-21.47,104.18l178.93,272.79c22.69,34.73,69.08,44.39,103.63,21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m840.57,902.79h-378.47l33.48-433.75c0-.11.03-.19.03-.3.71-9.18,2.31-18.06,4.76-26.7-.03-.03,0-.03,0-.03,8.26-29.59,26.04-55.5,50.01-74.95,28.67-23.31,66.29-37.33,107.22-37.33,32.83,0,63.44,9.02,89.04,24.54,7.34,4.45,14.24,9.43,20.68,14.89,1.77,1.48,3.51,3.01,5.19,4.59,27.7,25.58,45.47,60.44,47.35,99.27l20.71,429.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m540.57,663.08l-5.11,1.91c-23.29-63.15-36.66-129.11-39.84-196.24.71-9.18,2.31-18.06,4.76-26.7,0,3.72.05,7.51.14,11.45,1.77,71.75,15.22,142.28,40.06,209.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m772.51,373.77c-.24,3.69-.6,7.43-1.09,11.2-3.13,24.76-10.57,50.28-24.13,82.68-27.91,66.73-66.4,127.96-114.34,181.95l-4.05-3.63c47.54-53.56,85.7-114.27,113.39-180.42,13.37-31.97,20.68-57.03,23.75-81.26.65-5.08,1.09-10.14,1.28-15.11,1.77,1.48,3.51,3.01,5.19,4.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "509.15 902.79 509.15 1000 453.42 1000 462.07 902.79 509.15 902.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "854.32 1000 639.64 1000 639.64 900.85 639.76 900.85 723.32 899.42 811.51 897.91 823.17 897.71 840.29 897.43 840.33 897.51 840.33 897.63 854.32 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "729.19 574.59 721.24 580.27 783.69 679.34 791.64 673.66 729.19 574.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "486.14 552.14 492.12 548.81 475.21 741.98 469.72 737.07 486.14 552.14"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m747.59,354.88c-4.65,12.73-13.75,25-29.46,39.65-41.47,38.66-60.42,159.36-66.32,232.42-5.9,73.09-12.15,275.84-12.15,275.84h-130.49s-1.03-303.22,34.54-416.67c15.68-50.03,13.48-88.97,6.66-119.05,2.31-1.89,4.65-3.69,7.07-5.41,27.67-20.06,62.51-31.91,100.15-31.91,22.53,0,44.46,4.54,64.28,12.41,9.05,3.58,17.67,7.87,25.71,12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m775.47,883.8l-211.46-62.66c-5.01-1.48-7.88-6.77-6.4-11.81l101.8-347.26c1.48-5.04,6.74-7.92,11.75-6.43l211.46,62.66c5.01,1.48,7.88,6.77,6.4,11.81l-101.8,347.26c-1.48,5.04-6.74,7.92-11.75,6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m617.11,729.11l304.77-48.86c35.88-6,69.76,18.49,75.54,54.6h0c5.86,36.63-19.48,70.92-56.06,75.84l-292.35,31.24-31.89-112.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "659.94 723.7 659.09 718.3 890.57 681.19 891.42 686.58 659.94 723.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m682.14,762.99c-.11,4.96-.31,9.64-.6,14.09-3.14,49.33-16.78,67.02-35.25,67.24-18.06.22-43.08-2.44-59.43-37.2-1.9-4.02-3.67-8.47-5.3-13.38-2.36-7.13-3.6-14.75-3.96-22.6-.04-.53-.07-1.07-.07-1.6-.04-.64-.07-1.29-.04-1.96-.04-.51-.04-1.04-.04-1.56-.02-8.91.95-18,2.52-26.78.02-.24.07-.47.11-.69.24-1.38.51-2.73.8-4.09,0-.09.02-.18.04-.24,1.88-9.24,4.35-18.04,6.87-25.86.15-.47.31-.91.46-1.36.31-.98.64-1.96.95-2.89.09-.24.18-.47.24-.69,4.38-12.62,8.62-22.06,10.3-25.62.88-.33,1.77-.62,2.65-.87,1.22.42,2.98,1.09,5.19,1.98,17.15,6.87,60.29,27.44,71.74,64.08,1.92,6.2,2.96,12.84,2.81,19.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m608.03,710.09h-.02c-.62.22-1.24.4-1.9.51-2.94.58-6.34.31-10.1-1.07-2.43-.89-5.02-1.73-7.76-2.51-.6-.18-1.19-.33-1.81-.51,0,0-.53-.8-.66-3.13,0-.29-.02-.6-.02-.96,0-2.64.44-6.87,2.21-13.33,1.64-5.98,6.63-9.35,11.78-11.27.88-.33,1.77-.62,2.65-.87.04-.02.07-.02.09-.02,1.02.38,2.1.78,3.23,1.2.66.24,1.28.51,1.88.8,15.47,7.22,12.82,26.97.44,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m619.23,732.29c-1.46,5.13-5.81,9.93-11.01,12.24-3.71,1.69-7.87,2.09-11.71.44-4.88-2.07-10.52-4-16.55-5.71-1.37-.42-2.78-.8-4.22-1.18.15-.16.31-.33.46-.47,1.06-1.09,1.81-1.64,1.81-1.64,0,0-1.04-.82-1.79-2.69-.04-.07-.07-.13-.09-.22-.8-2-1.22-5.15.11-9.71,2.03-6.89,6.81-12.98,9.02-15.53.73-.84,1.17-1.31,1.17-1.31,0,0-.53-.8-.66-3.13,0-.29-.02-.6-.02-.96,1.24.33,2.48.67,3.69,1.02,2.87.84,5.68,1.71,8.35,2.64,2.96,1,5.75,2.07,8.38,3.18.15.07.29.11.42.18.49.2.95.42,1.41.64h.02c8.44,4.15,14.06,12.15,11.21,22.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m616.23,764.48c-1.81,6.42-8.29,12.31-15.21,13.27-2.3.31-4.69.07-6.94-.89-4.84-2.07-10.45-3.98-16.49-5.71-1.35-.38-2.7-.73-4.07-1.09.38-.51.77-.98,1.13-1.33.91-.98,1.59-1.47,1.59-1.47l-.02-.02c-.09-.13-.6-.82-1.26-1.89-1.94-3.09-5.33-9.44-4.8-15.55.46-5.33,3.4-9.4,5.57-11.71.15-.16.31-.33.46-.47,1.06-1.09,1.81-1.64,1.81-1.64,0,0-1.04-.82-1.79-2.69,1.57.38,3.12.78,4.64,1.2,7.58,1.98,14.7,4.31,21.06,6.91.66.27,1.33.53,1.99.82,1.52.64,2.98,1.42,4.31,2.31,6.54,4.33,10.43,11.38,8,19.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m586.86,807.12c-.97-.24-1.99-.58-3.03-1.04-1.61-.71-3.36-1.4-5.24-2.07-3.69-7.89-8.44-18.55-8.49-23.66-.02-4.69,1.77-8.11,3.43-10.29.38-.51.77-.98,1.13-1.33.91-.98,1.59-1.47,1.59-1.47.42.11.84.22,1.24.33,6.59,1.82,12.66,3.93,17.75,6.16,1.24.53,2.36,1.18,3.36,1.89.91.64,1.72,1.36,2.43,2.11,10.79,11.2,1.81,33.42-14.17,29.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m601.88,742.55c-.4,1.13-1.64,1.76-2.78,1.38-.15-.04-7.32-2.44-19.03-5.36-1.24-.33-2.52-.64-3.87-.96,1.06-1.09,1.81-1.64,1.81-1.64,0,0-1.04-.82-1.79-2.69-.04-.07-.07-.13-.09-.22,1.66.4,3.25.78,4.77,1.18,12.05,3,19.41,5.47,19.58,5.51.71.24,1.26.89,1.44,1.64.09.38.09.78-.04,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m606.17,710.4c-.02.07-.04.13-.07.2-.35,1.07-1.48,1.64-2.59,1.38-.18-.04-6.39-1.53-15.74-3.6-.8-.18-1.64-.36-2.52-.56.73-.84,1.17-1.31,1.17-1.31,0,0-.53-.8-.66-3.13,1.19.24,2.32.49,3.43.76,3.32.73,6.23,1.4,8.6,1.96,4.18.98,6.7,1.6,6.81,1.62.77.2,1.35.8,1.57,1.56.09.36.11.73,0,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m598.72,775.46c-.02.07-.07.11-.13.18-.4.71-1.26,1.02-2.1.64-.11-.07-7.18-3.29-18.96-6.73-.93-.27-1.88-.56-2.87-.82.91-.98,1.59-1.47,1.59-1.47l-.02-.02c-.09-.13-.6-.82-1.26-1.89.84.22,1.68.44,2.48.69,12.66,3.64,20.33,7.13,20.47,7.18.82.4,1.19,1.4.82,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m680.93,776.97c-.92-.33-1.53-1.24-1.45-2.26,1.17-14.08-1.68-29-1.7-29.15-.23-1.19.54-2.35,1.73-2.58,1.18-.23,2.34.55,2.57,1.74.13.63,2.99,15.67,1.78,30.36-.1,1.21-1.16,2.11-2.37,2.01-.2-.02-.38-.06-.55-.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m474.13,732.31c15.85,39.88,17.12,138.02-19.31,152.66-36.43,14.64-94.04-63.01-109.9-102.89-15.85-39.88.82-84.08,37.25-98.72,36.43-14.64,76.1,9.06,91.96,48.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "494.18 793.23 450.88 682.83 455.94 680.82 499.24 791.22 494.18 793.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m452.26,800.79c-2.19,4.44-4.18,8.69-5.97,12.76-19.99,45.16-16.07,67.19.19,76.01,15.89,8.62,39.29,17.93,69.81-5.22,3.54-2.68,7.16-5.79,10.87-9.37,5.39-5.22,10-11.39,13.93-18.17.28-.45.55-.91.8-1.39.34-.55.65-1.11.94-1.71.28-.43.52-.9.76-1.36,4.13-7.88,7.47-16.39,10.13-24.89.09-.23.16-.44.22-.66.42-1.33.81-2.66,1.18-3.99.04-.08.06-.17.07-.24,2.6-9.06,4.47-18.01,5.85-26.12.08-.49.15-.95.21-1.42.18-1.01.33-2.03.49-3,.03-.26.06-.5.1-.72,1.95-13.22,2.55-23.57,2.7-27.5-.63-.71-1.28-1.38-1.95-2.01-1.27-.19-3.15-.43-5.51-.67-18.36-1.92-66.08-3.82-93.13,23.3-4.56,4.59-8.55,10-11.71,16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m542.32,788.5h.02c.45.5.91.94,1.45,1.35,2.34,1.88,5.48,3.23,9.44,3.77,2.56.35,5.24.81,8.03,1.39.61.12,1.21.26,1.84.39,0,0,.84-.46,2.03-2.47.13-.26.3-.52.46-.84,1.22-2.34,2.78-6.29,4.2-12.84,1.31-6.06-1.56-11.38-5.24-15.47-.63-.71-1.28-1.38-1.95-2.01-.03-.04-.05-.05-.07-.06-1.07-.14-2.22-.29-3.41-.44-.7-.09-1.37-.15-2.03-.17-17.04-.82-23.81,17.91-14.77,27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m522.15,802.93c-1.08,5.23.56,11.51,4.1,15.98,2.51,3.23,6.01,5.52,10.17,5.86,5.28.45,11.17,1.36,17.3,2.66,1.41.27,2.84.59,4.28.93-.07-.21-.12-.44-.2-.63-.44-1.46-.85-2.3-.85-2.3,0,0,1.3-.24,2.83-1.55.07-.04.12-.09.18-.16,1.63-1.4,3.46-4,4.38-8.65,1.38-7.05-.04-14.67-.82-17.97-.26-1.09-.43-1.71-.43-1.71,0,0,.84-.46,2.03-2.47.13-.26.3-.52.46-.84-1.25-.28-2.5-.56-3.74-.82-2.93-.59-5.82-1.13-8.62-1.56-3.09-.5-6.04-.85-8.89-1.09-.17-.01-.31-.04-.45-.04-.52-.05-1.04-.07-1.55-.09h-.02c-9.4-.27-18.06,4.2-20.17,14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m509.95,832.86c-1.36,6.53,1.66,14.77,7.35,18.84,1.89,1.35,4.12,2.24,6.56,2.45,5.24.43,11.1,1.35,17.24,2.63,1.37.29,2.73.61,4.1.93-.1-.63-.23-1.23-.38-1.71-.35-1.29-.73-2.04-.73-2.04h.03c.14-.09.91-.46,1.99-1.09,3.15-1.83,9.08-5.88,11.43-11.54,2.05-4.94,1.32-9.91.47-12.97-.07-.21-.12-.44-.2-.63-.44-1.46-.85-2.3-.85-2.3,0,0,1.3-.24,2.83-1.55-1.56-.4-3.12-.76-4.67-1.1-7.63-1.78-15.01-3.04-21.85-3.7-.71-.07-1.42-.15-2.14-.2-1.65-.14-3.3-.13-4.88.04-7.79.79-14.49,5.21-16.3,13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m516.29,884.33c.97.24,2.03.42,3.16.49,1.76.12,3.62.33,5.59.61,6.91-5.27,16.04-12.5,18.44-17,2.18-4.14,2.18-8.01,1.71-10.71-.1-.63-.23-1.23-.38-1.71-.35-1.29-.73-2.04-.73-2.04-.42-.1-.85-.19-1.25-.28-6.68-1.46-13.03-2.42-18.56-2.83-1.34-.1-2.64-.06-3.85.11-1.1.15-2.15.4-3.13.74-14.72,4.89-17.03,28.76-1.01,32.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m532.78,820.12c-.17,1.19.64,2.32,1.83,2.52.16.03,7.61,1.25,19.33,4.13,1.25.28,2.53.6,3.87.96-.44-1.46-.85-2.3-.85-2.3,0,0,1.3-.24,2.83-1.55.07-.04.12-.09.18-.16-1.65-.42-3.24-.83-4.77-1.18-12.06-2.96-19.71-4.21-19.89-4.25-.74-.11-1.53.2-2.03.79-.25.29-.44.65-.49,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m543.82,789.64c-.01.07-.02.14-.03.21-.18,1.11.55,2.15,1.65,2.43.18.04,6.37,1.62,15.6,4.15.79.21,1.61.45,2.49.68-.26-1.09-.43-1.71-.43-1.71,0,0,.84-.46,2.03-2.47-1.17-.34-2.28-.65-3.38-.93-3.28-.9-6.17-1.67-8.52-2.28-4.15-1.08-6.67-1.71-6.78-1.74-.78-.18-1.56.08-2.11.65-.24.27-.44.6-.52,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m520.39,850.75c-.01.07,0,.13.04.22.02.82.64,1.49,1.56,1.55.13,0,7.88.44,19.91,2.88.95.2,1.92.38,2.92.61-.35-1.29-.73-2.04-.73-2.04h.03c.14-.09.91-.46,1.99-1.09-.85-.19-1.69-.39-2.51-.54-12.9-2.68-21.3-3.17-21.44-3.19-.91-.03-1.7.68-1.76,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m446.87,813.73c.96.14,1.93-.39,2.33-1.33,5.46-13.02,14.87-24.91,14.96-25.02.76-.95.61-2.33-.34-3.1-.95-.75-2.32-.61-3.08.34-.4.5-9.89,12.49-15.59,26.06-.47,1.12.05,2.41,1.17,2.88.18.08.36.13.55.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 700.26,
    y: 826.97,
    width: 136.78,
    height: 5.46,
    transform: "translate(-76.98 78.61) rotate(-5.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m550.3,143.48c2.57.06,54.39,21.55,69.12,62.9,14.73,41.35,12.15,98.54,27.43,113.76s36.59,8.82,37.09-7.28c0,0-38.58,6.83-42.14-10.09-3.55-16.93,35.51-133.33-18.83-161.78-54.34-28.45-72.68,2.5-72.68,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m721.88,342.15c-7.53,28.8-43.79,50.6-87.35,50.6-33,0-61.8-12.51-77.08-31.1,27.67-20.06,62.51-31.91,100.15-31.91,22.53,0,44.46,4.54,64.28,12.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "854.36 1000 823.41 1000 812.42 916.9 811.75 902.79 811.51 897.91 808.94 842.94 821.95 841.51 837.52 839.77 838.35 857.13 839.3 876.64 840.33 897.51 840.33 897.63 854.36 1000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m471.75,300.67c35.34-57.21,52.78-94.6,59.77-111.04,11.28-37.23,44.73-64.22,84.24-64.22,48.78,0,88.32,41.14,88.32,91.88,0,13.17-2.68,25.68-7.48,37.01.56,22.83,10.1,56.61,56.67,75.48,83.61,33.87,178.22,131.92,106.95,230.48-1.23,1.7-2.53,3.31-3.88,4.88l-1.48,5.21,95.09,150.02c8.57,13.58,12.25,29.02,11.5,44.09.95,16.92-4.6,32.9-14.52,45.15,31.35-7.01,53.07-35.91,51.21-68.04.79-15.42-3.1-31.23-12.18-45.12l-100.69-153.52,1.56-5.33c1.43-1.6,2.81-3.26,4.1-4.99,75.48-100.86-24.72-201.2-113.25-235.87-49.32-19.31-59.41-53.88-60.01-77.24,5.08-11.59,7.92-24.39,7.92-37.87,0-51.93-41.87-94.03-93.52-94.03-41.84,0-77.26,27.63-89.21,65.72-7.4,16.82-25.87,55.08-63.29,113.63-20.11,31.47-29.54,60.69-32.06,87.17,4.9-16.94,12.71-34.78,24.23-53.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m339.09,755.72c.66-10.73,3.59-21.48,9.03-31.47l124.35-227.28c-1.56-2.25-3.11-4.61-4.64-7.04l-119.16,210.49c-7.78,13.79-10.73,29.01-9.43,43.69-.33,3.82-.36,7.7-.14,11.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 91.3,
    y: 373.5,
    width: 223.11,
    height: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m297.19,473.96H102.62c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h194.56c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 97.72,
    y: 605.36,
    width: 121.47,
    height: 207.97,
    rx: 26.8,
    ry: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m204.65,512.06h-102.03c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h102.03c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m297.19,295.81H102.62c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h194.56c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 96.72,
    y: 322.03,
    width: 113.84,
    height: 11.88,
    rx: 5.94,
    ry: 5.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.61,250.61h-94.39c-5.8,0-10.5-4.73-10.5-10.56h0c0-5.83,4.7-10.56,10.5-10.56h94.39c5.8,0,10.5,4.73,10.5,10.56h0c0,5.83-4.7,10.56-10.5,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m172.48,428.1h-65.26c-5.8,0-10.5-4.73-10.5-10.56h0c0-5.83,4.7-10.56,10.5-10.56h65.26c5.8,0,10.5,4.73,10.5,10.56h0c0,5.83-4.7,10.56-10.5,10.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1054.36,
    y: 393.64,
    width: 164.6,
    height: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1198.19,514.79h-130.18c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h130.18c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1164.94,560.74h-96.92c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h96.92c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1065.8,
    y: 611.84,
    width: 100.26,
    height: 235.94,
    rx: 35.72,
    ry: 35.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1198.19,299.95h-130.18c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h130.18c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1164.94,345.9h-96.92c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h96.92c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1161.27,245.44h-87.71c-6.99,0-12.66-5.7-12.66-12.73h0c0-7.03,5.67-12.73,12.66-12.73h87.71c6.99,0,12.66,5.7,12.66,12.73h0c0,7.03-5.67,12.73-12.66,12.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1060.89,
    y: 434.02,
    width: 77.92,
    height: 25.46,
    rx: 12.73,
    ry: 12.73
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img_1.38f2a48e11c0f8327065806dc331dd1c.svg";
export { ForwardRef as ReactComponent };